import { useContext, useMemo } from 'react';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { TEDEKBokforderSTATUSEnum } from '../../../../../../globalQueryTypes';
import { useBusinessDataFormContext } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import BokforderContext from '../Components/BokforderContext/BokforderContext';
import { BokforderType__Associations_Rader } from '../Queries/_QueryTypes/BokforderType';

const useCantEditPeriod = () => {
  const { userID } = useContext(ActiveDatabaseContext);
  const formContext = useBusinessDataFormContext();
  const bokforderContext = useContext(BokforderContext);

  const isBestallare = useMemo(
    () =>
      formContext?.data?._Associations?.Bestallare?.id === userID ||
      formContext?.isNew,
    [
      formContext?.data?._Associations?.Bestallare?.id,
      formContext?.isNew,
      userID,
    ]
  );

  const attestRows: BokforderType__Associations_Rader[] = useMemo(
    () =>
      formContext?.data?._Associations?.Rader?.filter(
        (row: any) => row?._Associations?.Attestant?.id === userID
      ) ?? [],
    [formContext?.data?._Associations?.Rader, userID]
  );

  const haveAttesterat = useMemo(
    () => attestRows.every(row => row.ATTESTERAD_DATUM != null),
    [attestRows]
  );

  const attestantHaveAttesterat =
    (bokforderContext.isAttestant && haveAttesterat) ||
    (bokforderContext.isReservForAttestant &&
      bokforderContext.everyReservAttesterIsAttesterade);

  const isBestallareAndNotAttestantButWrongStatus =
    isBestallare &&
    !(bokforderContext.isAttestant || bokforderContext.isReservForAttestant) &&
    formContext?.data?.STATUS !== TEDEKBokforderSTATUSEnum.UTKAST &&
    formContext?.data?.STATUS !== TEDEKBokforderSTATUSEnum.EJ_GODKAND &&
    !formContext?.isNew;

  const isAttestantAndNotBestallareButWrongStatus =
    (bokforderContext.isAttestant || bokforderContext.isReservForAttestant) &&
    !isBestallare &&
    attestantHaveAttesterat &&
    formContext?.data?.STATUS !== TEDEKBokforderSTATUSEnum.VANTAR_PA_ATTEST;

  const isBestallareAndAttestantButWrongStatus =
    (bokforderContext.isAttestant || bokforderContext.isReservForAttestant) &&
    isBestallare &&
    formContext?.data?.STATUS !== TEDEKBokforderSTATUSEnum.UTKAST &&
    formContext?.data?.STATUS !== TEDEKBokforderSTATUSEnum.EJ_GODKAND &&
    formContext?.data?.STATUS !== TEDEKBokforderSTATUSEnum.VANTAR_PA_ATTEST &&
    !formContext?.isNew;

  return useMemo(
    () =>
      isBestallareAndNotAttestantButWrongStatus ||
      isAttestantAndNotBestallareButWrongStatus ||
      isBestallareAndAttestantButWrongStatus,
    [
      isBestallareAndNotAttestantButWrongStatus,
      isAttestantAndNotBestallareButWrongStatus,
      isBestallareAndAttestantButWrongStatus,
    ]
  );
};

export default useCantEditPeriod;
